import { UserProfile } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function UserProfilePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto py-8">
        <div className="mb-6">
          <Button
            variant="ghost"
            onClick={() => navigate(-1)}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Back
          </Button>
        </div>
        
        <div className="flex justify-center">
          <UserProfile 
            appearance={{
              elements: {
                rootBox: 'w-full max-w-2xl',
                card: 'shadow-lg border border-border',
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}